import { Text } from "@fluentui/react-components";
import { usePrevious } from "hooks/usePrevious";
import { useSelectedViewTab } from "hooks/useSelectedViewTab";
import { ROUTES } from "library/constants";
import {
  EBenefitTab,
  IBenefitImplementation,
  IBenefitPackage,
} from "library/types";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useInvalidateBenefitImplementationPackages } from "state/queries/useGetBenefitImplementationPackages";
import { BenefitImplementationPackages } from "../BenefitImplementationPackages/BenefitImplementationPackages";
import { PackageCardList } from "./PackageCardList";

type Props = {
  benefitImplementation: IBenefitImplementation;
  packageList: IBenefitPackage[];
  searchFilterValue?: string;
};

export function ManagePackagesView({
  benefitImplementation,
  packageList,
  searchFilterValue = "",
}: Props) {
  const { t } = useTranslation();
  const location = useLocation();
  const selectedTab = useSelectedViewTab();

  const invalidateBenefitPackages =
    useInvalidateBenefitImplementationPackages();

  const isHrPage = location.pathname.includes(ROUTES.HR);

  useEffect(() => {
    invalidateBenefitPackages();
  }, [selectedTab]);

  return (
    <div>
      <Text
        block
        weight="semibold"
        underline
        size={500}
        style={{
          marginBottom: "20px",
        }}
      >
        {t("hbh.implementedPackages.label")}
      </Text>
      {selectedTab === EBenefitTab.list && (
        <BenefitImplementationPackages
          benefitImplementation={benefitImplementation}
          packageList={packageList || []}
          searchFilterValue={searchFilterValue}
        />
      )}
      {selectedTab === EBenefitTab.grid && (
        <PackageCardList
          benefitImplementation={benefitImplementation}
          benefitPackages={packageList}
          openBenefitPackageEmployeesImplementation={isHrPage}
        />
      )}
    </div>
  );
}
